import { render, staticRenderFns } from "./BaseQuestion.vue?vue&type=template&id=e478f36c&"
import script from "./BaseQuestion.vue?vue&type=script&lang=js&"
export * from "./BaseQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports